import {
  DecorativeAsset,
  getCommonAssetPath,
  getGeoAssetPath,
  MainElementConfig,
  SupportedGeo,
} from '../../geo/config'
import { classNames } from '@monorepo/utils'
import styles from './styles.module.css'

export const renderDecorElements = (elements: DecorativeAsset[] | undefined) => {
  if (!elements || elements.length === 0) return null

  return elements.map(({ file, className, alt, fetchPriority }) => (
    <div
      key={className}
      className={classNames(styles.decorElementsWrapper, styles[`${className}_wrapper`])}
    >
      <img
        key={className}
        src={getCommonAssetPath(file)}
        className={classNames(styles[className], styles.abs)}
        alt={alt || 'Decorative element'}
        fetchPriority={fetchPriority || 'auto'}
        loading={fetchPriority === 'high' ? 'eager' : 'lazy'}
      />
    </div>
  ))
}

export const renderMainElement = (
  element: MainElementConfig | undefined,
  geo: SupportedGeo,
  isDesktop: boolean,
  isTablet: boolean,
  isLandscape?: boolean,
) => {
  if (!element) return null

  const device = isDesktop ? 'desktop' : isTablet || isLandscape ? 'tablet' : 'mobile'
  const assetPath = element.element[device]

  if (!assetPath) return null

  const baseClassName = element.element.className
  const deviceClassName = styles[`${baseClassName}-${device}`] || styles[baseClassName]
  return (
    <div
      className={classNames(
        styles.decorElementsWrapper,
        styles[`${element.element.className}_wrapper`],
      )}
    >
      <img
        src={getGeoAssetPath(geo, assetPath)}
        className={classNames(deviceClassName, styles.abs)}
        alt="Decorative element"
        fetchPriority={element.fetchPriority}
      />
    </div>
  )
}
